var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_958_2076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.90066 11.8C7.07222 12.9716 8.97172 12.9716 10.1433 11.8L10.1433 11.8L12.2847 9.65866C12.6819 9.27497 12.6929 8.64191 12.3093 8.24466C11.9256 7.84741 11.2925 7.83641 10.8953 8.22009C10.8869 8.22812 10.8787 8.23634 10.8707 8.24466L9.01535 10.0993L9 1C9 0.447719 8.55229 0 8 0C7.44772 0 7 0.447719 7 1L7.014 10.0847L5.17335 8.244C4.7761 7.86031 4.14304 7.87131 3.75935 8.26856C3.38507 8.65609 3.38507 9.27047 3.75935 9.658L5.90066 11.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.66663C14.4477 9.66663 14 10.1143 14 10.6666V13.7273C13.9996 13.8777 13.8778 13.9996 13.7273 13.9999H2.27266C2.12222 13.9996 2.00034 13.8777 2 13.7273V10.6666C2 10.1143 1.55228 9.66663 1 9.66663C0.447719 9.66663 0 10.1143 0 10.6666V13.7273C0.00146875 14.9818 1.01812 15.9985 2.27266 16H13.7273C14.9819 15.9985 15.9985 14.9818 16 13.7273V10.6667C16 10.1143 15.5523 9.66663 15 9.66663Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_958_2076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9c8171c78520b6eb9a9c0e76c12b6671.svg";
export { ForwardRef as ReactComponent };